import { render, staticRenderFns } from "./Consignment.vue?vue&type=template&id=2b975549"
import script from "./Consignment.vue?vue&type=script&lang=js"
export * from "./Consignment.vue?vue&type=script&lang=js"
import style0 from "./Consignment.vue?vue&type=style&index=0&id=2b975549&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports